import React, { useState, useEffect } from 'react';
import { ArrowLeft, Play, CheckCircle } from 'lucide-react';
import { trainingModules } from '@/data/trainingData';
import { TrainingProgress } from '@/services/trainingProgress';

export const TrainingModulePage = ({ moduleId, onBack, onStartSession }) => {
  const [module, setModule] = useState(null);
  const [isCompleted, setIsCompleted] = useState(false);
  
  useEffect(() => {
    const moduleData = trainingModules.find(m => m.id === moduleId);
    setModule(moduleData);
    setIsCompleted(TrainingProgress.isModuleComplete(moduleId));
    
    TrainingProgress.updateModuleProgress(moduleId, { viewed: true });
  }, [moduleId]);
  
  const handleMarkComplete = () => {
    TrainingProgress.markModuleComplete(moduleId);
    setIsCompleted(true);
  };
  
  if (!module) {
    return <div className="min-h-screen flex items-center justify-center">
      <p className="text-slate-400">Yükleniyor...</p>
    </div>;
  }
  
  return (
    <div className="min-h-screen p-4 md:p-8" data-testid="training-module-page">
      <div className="max-w-4xl mx-auto space-y-8">
        <div className="flex items-center gap-4">
          <button onClick={onBack} className="text-slate-400 hover:text-slate-200 transition-colors" data-testid="module-back-btn">
            <ArrowLeft className="w-6 h-6" />
          </button>
          <div className="flex-1">
            <p className="text-xs tracking-widest uppercase text-violet-400 mb-1">Modül {module.id}</p>
            <h1 className="text-3xl font-heading text-slate-100">{module.title}</h1>
            <p className="text-slate-400 text-sm mt-2">{module.description}</p>
          </div>
          {isCompleted && <CheckCircle className="w-8 h-8 text-green-400" />}
        </div>
        
        <div className="glass-panel p-8 space-y-6">
          <h2 className="text-lg font-heading text-slate-100 flex items-center gap-2">
            <Play className="w-5 h-5 text-violet-400" />
            Modül İçeriği
          </h2>
          <div className="aspect-video bg-black/60 rounded-lg flex items-center justify-center border border-white/5">
            <div className="text-center space-y-2">
              <Play className="w-16 h-16 text-slate-600 mx-auto" />
              <p className="text-sm text-slate-500">Eğitim içeriği yer tutucu</p>
              <p className="text-xs text-slate-600">Tam müfredat yakında</p>
            </div>
          </div>
        </div>
        
        <div className="glass-panel p-8 space-y-6 bg-violet-500/5">
          <h2 className="text-lg font-heading text-slate-100">Pratik Egzersizi</h2>
          <p className="text-slate-300 leading-relaxed">
            Bu modülden öğrendiklerinizi, yüksek farkındalıkla bir kalibrasyon oturumu tamamlayarak uygulayın.
          </p>
          <button
            onClick={onStartSession}
            className="w-full md:w-auto rounded-full bg-violet-500/20 px-8 py-3 text-sm font-medium text-violet-300 transition-all hover:bg-violet-500/30 border border-violet-500/30"
            data-testid="module-practice-btn"
          >
            Kalibrasyon Oturumunu Aç
          </button>
        </div>
        
        <div className="flex justify-center pt-4">
          {!isCompleted ? (
            <button
              onClick={handleMarkComplete}
              className="rounded-full bg-white/5 px-8 py-3 text-sm font-medium text-white transition-all hover:bg-white/10 border border-white/10"
              data-testid="mark-complete-btn"
            >
              Modülü Tamamlandı Olarak İşaretle
            </button>
          ) : (
            <div className="flex items-center gap-2 text-green-400">
              <CheckCircle className="w-5 h-5" />
              <span className="text-sm font-medium">Modül Tamamlandı</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
